import React from "react";
import { Box } from "@material-ui/core";
import { BRAND } from "src/theme/brandTokens";

// Aviso para EN_RENEGOCIACION. El enlace del cliente sigue vivo a propósito
// -puede volver a abrirlo para confirmar que su solicitud llegó- pero el
// backend exige PENDIENTE para aceptar o rechazar, así que aquí no se
// ofrece ninguna acción: mostrar botones que el servidor va a rechazar es
// peor que no mostrar ninguno. La propuesta no tiene un desenlace que
// comunicar todavía, por eso este aviso vive aparte del banner de estados
// terminales en vez de sumarse a su mapa.
const RenegociacionNotice = () => (
  <Box
    component="section"
    sx={{
      bgcolor: BRAND.color.primaryBg,
      borderTop: `3px solid ${BRAND.color.primary}`,
      width: "100%",
    }}
  >
    <Box
      sx={{
        maxWidth: 1280,
        mx: "auto",
        px: { xs: 3, md: 5 },
        py: { xs: 4, md: 5 },
        display: "flex",
        flexDirection: "column",
        gap: 1,
      }}
    >
      <Box
        sx={{
          fontSize: BRAND.font.size.eyebrow,
          color: BRAND.color.primaryDark,
          textTransform: "uppercase",
          letterSpacing: BRAND.font.letterSpacing.widest,
          fontWeight: BRAND.font.weight.medium,
        }}
      >
        Estado de la propuesta
      </Box>

      <Box
        sx={{
          fontFamily: BRAND.font.family.base,
          fontSize: BRAND.font.size.bodyLarge,
          color: BRAND.color.inkSoft,
          lineHeight: BRAND.font.lineHeight.body,
          maxWidth: 720,
        }}
      >
        Estamos revisando lo que nos pediste. Te enviaremos una versión
        actualizada de la propuesta apenas esté lista.
      </Box>
    </Box>
  </Box>
);

export default React.memo(RenegociacionNotice);
